import angular from 'angular';
import 'angular-ui-router';
import 'angular-ui-router-title';
import CohortsShow from './cohortsShow.js';

export default angular.module('app.components.cohorts', [
  'ui.router',
  CohortsShow.name
])
  .config(function($stateProvider) {
    $stateProvider
      .state('app.cohorts', {
        abstract: true,
        url: '/cohorts/:gameId',
        template: '<ui-view/>',
        data: {
          permissions: {
            except: ['anonymous'],
            redirectTo: 'login'
          }
        },
        resolve: {
          game: function($stateParams,GamesResource,currentGame){
            return GamesResource.one($stateParams.gameId).get()
              .then(game => {
                return game;
              });
          },
          gameCurrency: function($stateParams,game,currentGame){
            return game.getGameDeveloper()
              .then((gameDeveloper) => {
                game.currency = gameDeveloper.currency;
                currentGame.onNext(game);
              });
          }
        }
      })
      .state('app.cohorts.show', {
        url: '?reportType&groupBy&metric&campaignType&dateRange&startDate&endDate&countryCode&deviceOs&deviceType&creativeType&campaignId&segmentId&creativeId',
        template: '<cohorts-show></cohorts-show>',
        reloadOnSearch: false,
        params: {
          campaignId: null,
          campaignType: null
        },
        resolve: {
          $title: ($filter, $stateParams) => {
            return $filter('translate')('$state.app.cohorts.show', {id: $stateParams.gameId});
          }
        }
      })
  });


/** WEBPACK FOOTER **
 ** ./src/components/cohorts/cohorts.js
 **/